import React from "react"; //Material imports

import makeStyles from "@material-ui/core/styles/makeStyles";
import LightbulbOutline from "../../icons/LightbulbOutline"; //Limitless imports

import SystemDialogue from "../system-dialogue/SystemDialogue";
var useStyles = makeStyles(function (_ref) {
  var _palette$dialogues$sy, _palette$dialogues, _palette$dialogues$sy2, _palette$dialogues$sy3, _palette$dialogues2, _palette$dialogues2$s, _palette$dialogues$sy4, _palette$dialogues3, _palette$dialogues3$s;

  var palette = _ref.palette;
  var background = (_palette$dialogues$sy = (_palette$dialogues = palette.dialogues) === null || _palette$dialogues === void 0 ? void 0 : (_palette$dialogues$sy2 = _palette$dialogues.system) === null || _palette$dialogues$sy2 === void 0 ? void 0 : _palette$dialogues$sy2.background) !== null && _palette$dialogues$sy !== void 0 ? _palette$dialogues$sy : palette.contrast.main;
  var text = (_palette$dialogues$sy3 = (_palette$dialogues2 = palette.dialogues) === null || _palette$dialogues2 === void 0 ? void 0 : (_palette$dialogues2$s = _palette$dialogues2.system) === null || _palette$dialogues2$s === void 0 ? void 0 : _palette$dialogues2$s.text) !== null && _palette$dialogues$sy3 !== void 0 ? _palette$dialogues$sy3 : palette.contrast.light;
  var borderRadius = (_palette$dialogues$sy4 = (_palette$dialogues3 = palette.dialogues) === null || _palette$dialogues3 === void 0 ? void 0 : (_palette$dialogues3$s = _palette$dialogues3.system) === null || _palette$dialogues3$s === void 0 ? void 0 : _palette$dialogues3$s.borderRadius) !== null && _palette$dialogues$sy4 !== void 0 ? _palette$dialogues$sy4 : 4;
  return {
    primaryBackground: {
      backgroundColor: background,
      borderRadius: borderRadius
    },
    primaryText: {
      color: text
    }
  };
});

var SystemInfoDialogue = function SystemInfoDialogue(_ref2) {
  var rest = Object.assign({}, _ref2);
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(SystemDialogue, Object.assign({
    dialogueClasses: classes,
    Icon: /*#__PURE__*/React.createElement(LightbulbOutline, {
      className: classes.primaryText
    })
  }, rest));
};

export default SystemInfoDialogue;